import LegalLayout from "./LegalLayout";

export default function PrivacyHr() {
  return (
    <LegalLayout
      testId="privacy-hr-page"
      eyebrow="Pravno"
      title="Politika privatnosti"
      updated="Veljača 2026."
    >
      <section>
        <h2>1. Tko smo mi</h2>
        <p>
          <strong>JUKE TRANSFERS j.d.o.o.</strong> (OIB: 05308456115), Mosećka ul. 34, 21000
          Split, Hrvatska, voditelj je obrade osobnih podataka prikupljenih putem ove web
          stranice i tijekom postupka rezervacije.
        </p>
      </section>

      <section>
        <h2>2. Što prikupljamo</h2>
        <p>
          Prikupljamo isključivo podatke potrebne za planiranje i izvršenje vašeg prijevoza:
        </p>
        <ul>
          <li>Ime i prezime</li>
          <li>E-mail adresa</li>
          <li>Broj telefona</li>
          <li>Adresa preuzimanja i dostave, datum i vrijeme, broj putnika i prtljage</li>
          <li>Broj leta i zrakoplovna kompanija (samo kada je relevantno za dolazak sa zračne
              luke)</li>
          <li>Sve posebne upute koje odlučite unijeti u polje za napomene</li>
        </ul>
        <p>
          Ne prikupljamo brojeve platnih kartica na vlastitim poslužiteljima. Ako je potreban
          depozit, plaćanje obrađuje PCI-DSS usklađen pružatelj usluga.
        </p>
      </section>

      <section>
        <h2>3. Kako koristimo vaše podatke</h2>
        <p>
          Vaši se podaci koriste <strong>isključivo za rezervaciju i logistiku prijevoza</strong>:
        </p>
        <ul>
          <li>Potvrda i koordinacija vašeg prijevoza s dodijeljenim vozačem.</li>
          <li>Slanje potvrda rezervacija, podsjetnika i računa e-poštom.</li>
          <li>Praćenje vašeg leta (putem licenciranog pružatelja podataka o letovima) radi
              usklađivanja vremena preuzimanja.</li>
          <li>Kontaktiranje telefonom ili WhatsApp-om na dan prijevoza po potrebi.</li>
          <li>Ispunjavanje naših zakonskih obveza (izdavanje računa, porezne evidencije) prema
              hrvatskim zakonima.</li>
        </ul>
        <p>
          Vaše osobne podatke <strong>ne</strong> prodajemo, iznajmljujemo niti dijelimo s
          trećim stranama u marketinške svrhe.
        </p>
      </section>

      <section>
        <h2>4. Sigurnost</h2>
        <p>
          Vaši podaci prenose se putem šifriranih HTTPS veza i pohranjuju u sigurnoj bazi
          podataka s pristupom ograničenim na ovlašteno osoblje po načelu potrebe znanja.
          Sigurnosne kopije šifrirane su u mirovanju. Lozinke za interne sustave hashirane su
          industrijski standardnim algoritmima.
        </p>
      </section>

      <section>
        <h2>5. Rok čuvanja</h2>
        <p>
          Zapisi o rezervacijama čuvaju se onoliko koliko zahtijeva hrvatsko računovodstveno i
          porezno zakonodavstvo (trenutno 11 godina). Marketinške komunikacije, u koje ste
          izričito pristali, možete otkazati u bilo kojem trenutku.
        </p>
      </section>

      <section>
        <h2>6. Vaša prava prema GDPR-u</h2>
        <p>Prema EU Općoj uredbi o zaštiti podataka, imate pravo:</p>
        <ul>
          <li>Pristupiti osobnim podacima koje o vama posjedujemo.</li>
          <li>Zatražiti ispravak netočnih podataka.</li>
          <li>Zatražiti brisanje vaših podataka (uz obveze zakonskog čuvanja).</li>
          <li>Prigovoriti obradi ili je ograničiti.</li>
          <li>Zatražiti kopiju svojih podataka u prenosivom formatu.</li>
          <li>Podnijeti prigovor Agenciji za zaštitu osobnih podataka (AZOP).</li>
        </ul>
      </section>

      <section>
        <h2>7. Kolačići</h2>
        <p>
          Ova web stranica koristi mali broj neophodnih kolačića kako bi stranica funkcionirala
          (npr. vaša preferencija jezika) i neobavezne kolačiće za analitiku kako bismo razumjeli
          kako posjetitelji koriste stranicu. Neobavezne kolačiće možete prihvatiti ili odbiti
          putem banera pri prvoj posjeti. Odbijanje neobaveznih kolačića ne utječe na vašu
          mogućnost rezervacije prijevoza.
        </p>
      </section>

      <section>
        <h2>8. Kontakt</h2>
        <p>
          Za ostvarivanje bilo kojeg od vaših prava ili za pitanja o načinu na koji rukujemo
          vašim podacima, obratite nam se na{" "}
          <a href="mailto:bookings@juketransfers.hr" className="text-[#C5A059] hover:text-[#D4AF37] underline underline-offset-2">bookings@juketransfers.hr</a>.
        </p>
      </section>
    </LegalLayout>
  );
}
